/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from '../../core/services/settings/pre-init-setting.service';

@Injectable({
  providedIn: 'root'
})

export class CPRCouponModalService {
  middlewareUrl: string;
  billingPath: string;
  cprcouponpath: string;
  sfSite: string;
  sfProvider: string;
  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.cprcouponpath = this.preInitSettingsService.getSettings().middleWare.cprcouponpath;
    this.sfSite = this.preInitSettingsService.getSiteSettings().id;
    this.sfProvider = this.preInitSettingsService.getSiteSettings().provider;
  }

  /**
   * @deprecated This method should not be used in any new code that is written. This is called for the old CAS clients and won't work for any of our new clients. This API call causes retrieving content (on the backend function app) from the old way of using Sitefinity and it wasn't refactored into the new way of Sitefinity. So if this method is for whatever reason needing to be used for any new client we set up, then we will need to refactor this method to pull content from the new way of doing Sitefinity (using the Portal Contents or Portal Settings or etc...). Because the goal is that when we create a new client we don't have to configure any settings in the old Sitefinity way because that would lead to confusion when creating a new client.
   * 
   * @param data 
   * @returns 
   */
  redeemCoupon(data): Observable<any> {
    data = { ...data, SfSite: this.sfSite, SfProvider: this.sfProvider };
    return this.http.post<any>(this.middlewareUrl + this.cprcouponpath, data);
  }
}
